import { DatePicker, Form, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { RecoilState, useRecoilState } from "recoil";
// eslint-disable-next-line import/no-extraneous-dependencies
import CalendarLocale from "rc-picker/lib/locale/ru_RU";
import {
  CompanyServiceMatchType,
  CompanyType,
  ReportFilterType,
} from "../../../../types";
import {
  apiCompaniesList,
  apiOrganizationServiceList,
} from "../../../../api/api";

export const FilterReportsModal = ({
  isVisible,
  setVisible,
  filterState,
}: {
  isVisible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  filterState: RecoilState<ReportFilterType>;
}) => {
  const [form] = Form.useForm<any>();
  const [filter, setFilter] = useRecoilState(filterState);
  const [companies, setCompanies] = useState<CompanyType[] | undefined>(
    undefined
  );
  const [services, setServices] = useState<
    CompanyServiceMatchType[] | undefined
  >(undefined);
  const [selectedCompany, setSelectedCompany] = useState<string | undefined>(
    undefined
  );

  const saveNewFilter = (values: { [index: string]: any }) => {
    const { companyId, serviceId, datesRange } = values;
    const [endDate, startDate] = datesRange
      ? [datesRange[0].format("YYYY-MM-DD"), datesRange[1].format("YYYY-MM-DD")]
      : [null, null];

    setFilter({
      companyId: companyId || null,
      serviceId: serviceId || null,
      dateBeginFiltered: startDate || null,
      dateEndFiltered: endDate || null,
      momentRange: datesRange || null,
    });
    setVisible(false);
  };

  const getCompanies = async () => {
    const resp = await apiCompaniesList();
    setCompanies(resp.result);
  };

  const getOrganizationServiceList = async () => {
    const resp = await apiOrganizationServiceList();
    setServices(resp.result);
  };

  useEffect(() => {
    if (isVisible) {
      form.setFields([
        {
          name: "datesRange",
          value: filter.momentRange,
        },
        {
          name: "serviceId",
          value: filter.serviceId,
        },
        {
          name: "companyId",
          value: filter.companyId,
        },
      ]);
      getCompanies();
      getOrganizationServiceList();
    }
  }, [isVisible]);

  return (
    <Modal
      title="Текущий фильтр"
      visible={isVisible}
      onOk={() => form.submit()}
      onCancel={() => setVisible(false)}
      afterClose={() => {
        form.resetFields();
      }}
      width="500px"
      cancelText="Закрыть"
      okText="Применить"
      forceRender
    >
      <Form
        form={form}
        onFinish={saveNewFilter}
        labelCol={{
          span: 5,
        }}
      >
        <Form.Item label="Период" name="datesRange">
          <DatePicker.RangePicker
            locale={{
              lang: {
                placeholder: "Выберите дату",
                yearPlaceholder: "Выберите год",
                quarterPlaceholder: "Выберите квартал",
                monthPlaceholder: "Выберите месяц",
                weekPlaceholder: "Выберите неделю",
                rangePlaceholder: ["Начальная дата", "Конечная дата"],
                rangeYearPlaceholder: ["Начальный год", "Год окончания"],
                rangeMonthPlaceholder: ["Начальный месяц", "Конечный месяц"],
                rangeWeekPlaceholder: ["Начальная неделя", "Конечная неделя"],
                ...CalendarLocale,
                shortMonths: [
                  "Январь",
                  "Февраль",
                  "Март",
                  "Апрель",
                  "Май",
                  "Июнь",
                  "Июль",
                  "Август",
                  "Сентябрь",
                  "Октябрь",
                  "Ноябрь",
                  "Декабрь",
                ],
                shortWeekDays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
              },
              timePickerLocale: {
                placeholder: "Выберите время",
              },
            }}
            placeholder={["Начальная дата", "Конечная дата"]}
            format="YYYY-MM-DD"
          />
        </Form.Item>
        <Form.Item label="Организация" name="companyId">
          <Select
            loading={!companies}
            placeholder="Организация"
            allowClear
            onChange={(value: string) => {
              form.setFields([
                {
                  name: "serviceId",
                  value: undefined,
                },
              ]);
              setSelectedCompany(value);
            }}
          >
            {companies?.map((el) => (
              <Select.Option value={el.inn}>{el.companyName}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Услуга" name="serviceId">
          <Select placeholder="Название услуги" loading={!services}>
            {services &&
              selectedCompany &&
              (services?.filter((el) => el.inn === selectedCompany) || []).map(
                (el) => (
                  <Select.Option value={el.serviceId}>
                    {el.serviceName}
                  </Select.Option>
                )
              )}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
